export const enrollInfo = {
    '1': '统招',
    '2': '单招(高考生批次)',
    '3': '单招(中职生批次)',
    '4': '意向报读',
    '5': '普通招生',
}

//新增锦州模版字段
export const jinzhouTemplateParams = [
  {
      key: "majorAdjust",
      name: "专业调剂",
      type: 4,  //1是文本，2是数字，3是下拉框，4是单选
  },
  {
      key: "foreignLanguage",
      name: "外语语种",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "belCantoPiano",
      name: "美声(钢琴)省统考",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "folkVoicePiano",
      name: "民声(钢琴)省统考",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "zkSportComprehensiveScore",
      name: "体育专综合分",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "cultureRawScore",
      name: "文化课原始分",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "inProvinceTotalScore",
      name: "省内总分",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "outProvinceTotalScore",
      name: "省外总分",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "bkSportComprehensiveScore",
      name: "体育本综合分",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "artScore",
      name: "艺术分",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "candidateCharacter",
      name: "考生特征",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "foreignLanguageListening",
      name: "外语听力",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "medicalRestrictRemark",
      name: "体检受限备注",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "volunteerNumber",
      name: "志愿号",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "candidateNumber",
      name: "考生号",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "birthday",
      name: "出生日期",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "politicalStatus",
      name: "政治面貌",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "nationality",
      name: "民族",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "admissionScore",
      name: "投档成绩",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "admissionMajor",
      name: "录取专业",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "chineseRemark",
      name: "中文备注",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "englishRemark",
      name: "英文备注",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "batchNumber",
      name: "批次号",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "collegeName",
      name: "学院名称",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "provinceName",
      name: "省份名称",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "noticeMailingAddress",
      name: "通知书邮寄地址",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "postalCode",
      name: "邮政编码",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "mobilePhone",
      name: "手机",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "recipient",
      name: "收件人",
      type: 1,  //1是文本，2是数字
  },
  {
      key: "candidateCategory",
      name: "考生类别",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "graduationCategory",
      name: "毕业类别",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "examType",
      name: "考试类型",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "scienceCategoryName",
      name: "科类名称",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "graduationSchoolCode",
      name: "毕业学校代码",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "graduationSchoolName",
      name: "毕业学校名称",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "householdCategory",
      name: "户籍类别",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "studentStatusNumber",
      name: "学籍号",
      type: 1,  //1是文本，2是数字
  },
  // {
  //     key: "foreignJobSkill",
  //     name: "外语职测技能",
  //     type: 1,  //1是文本，2是数字
  // },
  {
      key: "chaoMengLanguage",
      name: "朝(蒙)语文",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "chineseLanguage",
      name: "汉语文",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "languageScore",
      name: "语文",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "mathScore",
      name: "数学",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "foreignJobSkill",
      name: "外语、职测、技能",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "physicsScore",
      name: "物理",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "chemistryScore",
      name: "化学",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "biologyScore",
      name: "生物",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "politicScore",
      name: "政治",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "historyScore",
      name: "历史",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "geographyScore",
      name: "地理",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "candidateIndexNumber",
      name: "考生索引号",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "expressNumber",
      name: "特快号",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "sportScore",
      name: "体育分",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "listeningScore",
      name: "听力分",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "jobScore",
      name: "职测分",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "skillScore",
      name: "技能分",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "foreignLanguageScore",
      name: "外语分",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "totalScore",
      name: "总分",
      type: 2,  //1是文本，2是数字
  },
  {
      key: "jzMajor01",
      name: "专业1",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "jzMajor02",
      name: "专业2",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "jzMajor03",
      name: "专业3",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "jzMajor04",
      name: "专业4",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "jzMajor05",
      name: "专业5",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "jzMajor06",
      name: "专业6",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "jzMajor07",
      name: "专业7",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "jzMajor08",
      name: "专业8",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "jzMajor09",
      name: "专业9",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "jzMajor10",
      name: "专业10",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "jzMajor11",
      name: "专业11",
      type: 3,  //1是文本，2是数字
  },
  {
      key: "jzMajor12",
      name: "专业12",
      type: 3,  //1是文本，2是数字
  },
]